import type { WDedicatedJobOffersTranslations } from "./pl";

export const en: WDedicatedJobOffersTranslations = {
  apply: "Apply",
  sendCv: "Send CV",
};
